import { InvoicesApiBase } from './paymentApi';

class InvoicesApi extends InvoicesApiBase {
}

export default new InvoicesApi();